/**
 *  decrypt base 64 string
 *
 *
 */
import CryptoJS from 'crypto-js';

export const decrypt = function (encryptedString, key) { // eslint-disable-line
  const json = JSON.parse(CryptoJS.enc.Utf8.stringify(
    CryptoJS.enc.Base64.parse(encryptedString),
  ));

  const salt = CryptoJS.enc.Hex.parse(json.salt);
  const iv = CryptoJS.enc.Hex.parse(json.iv);

  const encrypted = json.ciphertext;

  let iterations = parseInt(json.iterations, 10);
  if (iterations <= 0) {
    iterations = 999;
  }
  const encryptMethodLength = (256 / 4);
  const hashKey = CryptoJS.PBKDF2(
    key,
    salt,
    { hasher: CryptoJS.algo.SHA512, keySize: (encryptMethodLength / 8), iterations },
  );

  const decrypted = CryptoJS.AES.decrypt(encrypted, hashKey, { mode: CryptoJS.mode.CBC, iv });

  return decrypted.toString(CryptoJS.enc.Utf8);
};
